import React, { useEffect, useContext, useRef } from 'react';
import './Comfort.scss';
import VideoSimple from '@/v2/components/media/video/VideoSimple';
import TimelineText from '@/v2/components/atoms/TimelineText';
import Header from '@/v2/components/application/Header';
import Disclaimer from '@/v2/components/layouts/Disclaimer';
import { PerformanceContext } from '@/v2/state/providers';
import { MomentStateContext } from '@/v2/state/momentState';

let activated = false;
let videoController = null;

const videoReady = (controller, onReady, setTime) => {
    videoController = controller;
    videoController.AddOnTimeUpdated(() => {
        setTime(videoController.GetTime());
    });

    onReady();
};

const play = () => {
    videoController.Play();
};

const videoFinished = (onFinished) => {
    onFinished();
};

const activate = () => {
    if (activated) return;
    activated = true;
    play();
};

export default ({ isActive, data, onFinished, onReady }) => {
    const [{ disclaimer }] = useContext(PerformanceContext);
    const { dispatch: momentDispatch } = useContext(MomentStateContext);

    const time = useRef(TimelineText.Time());

    useEffect(() => {
        activated = false;
    }, []);

    useEffect(() => {
        if (isActive && videoController) {
            videoController.ProgressDispatch(momentDispatch);
            activate();
        }
    }, [isActive, videoController]);

    const options = {
        bufferBeforePlay: true,
        onReady: (controller) => videoReady(controller, onReady, time.current.Set),
        autoPlay: true,
        onFinished: () => videoFinished(onFinished),
    };

    const headerContent = <Header show={isActive} hideLogo dark />;
    const disclaimerContent = isActive && disclaimer ? <Disclaimer data={disclaimer} dark /> : '';
    const timeLineText = isActive ? <TimelineText data={data.text.timeline} time={time.current} background="dark" color="black" /> : '';

    return (
        <div className="Comfort">
            <VideoSimple src={data.video} options={options} />
            {headerContent}
            {timeLineText}
            {disclaimerContent}
        </div>
    );
};
